import {
  FETCH_PERMISSIONS_REQUEST,
  FETCH_PERMISSIONS_SUCCESS,
  FETCH_PERMISSIONS_FAILURE,
  UPDATE_PERMISSION
} from '../actions/types';

const initialState = {
  items: [],
  loading: false,
  error: null,
  lastFetched: null
};

const permissionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PERMISSIONS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case FETCH_PERMISSIONS_SUCCESS:
      return {
        ...state,
        items: action.payload,
        loading: false,
        error: null,
        lastFetched: new Date().toISOString()
      };

    case FETCH_PERMISSIONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    case UPDATE_PERMISSION: {
      const nextItems = Array.isArray(state.items) ? [...state.items] : [];
      const incoming = action.payload;
      const incomingId = incoming?._id;

      if (!incomingId) {
        return state;
      }

      const existingIndex = nextItems.findIndex(
        (item) => String(item?._id) === String(incomingId)
      );
      if (existingIndex === -1) {
        nextItems.push(incoming);
      } else {
        nextItems[existingIndex] = incoming;
      }

      return {
        ...state,
        items: nextItems,
        lastFetched: new Date().toISOString()
      };
    }

    default:
      return state;
  }
};

export default permissionsReducer;
